import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down', 'ArrowDown', [["path",{"d":"M12 4.5v15m0 0-6-5.625m6 5.625 6-5.625","key":"svg-0"}]]);